<template>
	<footer id="site-footer" class="in-module" role="contentinfo" itemscope="itemscope" itemtype="http://schema.org/WPFooter">
    <a href="#app" class="pagetop"><span>▲ ページの先頭へ</span></a>
    <div class="max">
      <div class="company">
        <figure><img src="/images/common/logo_w.webp" alt="株式会社ナビック・ワン "></figure>
        <p>〒263-0031 千葉県千葉市稲毛区稲毛東3丁目8-13 エクセレンス稲毛7階<br>TEL.043-239-6863 / FAX.043-239-6864</p>
      </div>
      <nav>
        <ul id="fnav">
          <li itemprop="name"><a itemprop="url" href="/"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="m531.69-480-184-184L376-692.31 588.31-480 376-267.69 347.69-296l184-184Z"/></svg>トップページ</a></li>
          <li itemprop="name"><a itemprop="url" href="/about/"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="m531.69-480-184-184L376-692.31 588.31-480 376-267.69 347.69-296l184-184Z"/></svg>会社概要</a></li>
          <li itemprop="name"><a itemprop="url" href="/business/"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="m531.69-480-184-184L376-692.31 588.31-480 376-267.69 347.69-296l184-184Z"/></svg>事業実績</a></li>
          <li itemprop="name"><a itemprop="url" href="/contact/"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="m531.69-480-184-184L376-692.31 588.31-480 376-267.69 347.69-296l184-184Z"/></svg>お問い合わせ</a></li>
          <li itemprop="name"><a itemprop="url" href="/news/"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="m531.69-480-184-184L376-692.31 588.31-480 376-267.69 347.69-296l184-184Z"/></svg>新着情報</a></li>
        </ul>
      </nav>
    </div>
    <small class="copy">Copyright &copy; {{ currentYear }} Navic-one All rights reserved.</small>
	</footer>
</template>

<style lang="scss" scoped>
footer{
  background: module.$light;
  color: module.$gray;
  position: relative;
  z-index: 10;
  a{
    color: module.$gray;
  }
  .pagetop{
    border-bottom: rgba(module.$white,.08) 1px solid;
    display: block;
    text-align: center;
    padding: 1rem 0;
    position: relative;
    &:before{
      content: '';
      width: 100%;
      height: 2.4rem;
      background: module.$light;
      position: absolute;
      top: 0;
      left: 0;
      transform: translateY(-100%);
      clip-path: polygon(50% 0, 100% 100%, 0 100%);
    }
    span{
      display: block;
      transform: translateY(-1rem);
    }
  }
  .max{
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: module.side2x();
    padding: 4rem module.side();
    @media screen and (max-width: module.$phone){
      grid-template-columns: 1fr;
      padding: 3.2rem module.side();
    }
  }
  .company{
    display: grid;
    grid-gap: .56rem;
    @media screen and (max-width: module.$tab){
      justify-self: center;
    }
    figure{
      width: 15.6rem;
      @media screen and (max-width: module.$phone){
        margin: 0 auto 1rem;
      }
      img{
        opacity: .8;
        width: 100%;
        object-fit: cover;
      }
    }
    p{
      font-size: .92rem;
      @media screen and (max-width: module.$phone){
        text-align: center;
      }
    }
  }
  nav{
    min-width: 32rem;
    justify-self: flex-end;
    align-self: center;
    @media screen and (max-width: module.$phone){
      min-width: 1px;
      justify-self: auto;
    }
    ul{
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 1rem;
      grid-row-gap: .4rem;
      @media screen and (max-width: module.$phone){
        grid-template-columns: repeat(2, 1fr);
        gap: 1px;
        text-align: left;
      }
      li{
        @media screen and (max-width: module.$phone){
          &:first-of-type{
            display: none;
          }
        }
        a{
          font-size: .92rem;
          position: relative;
          display: block;
          padding: 0 0 0 1.6rem;
          svg{
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            width: 1rem;
            @media screen and (max-width: module.$phone){
              right: .4rem;
              left: auto;
            }
          }
          @media screen and (max-width: module.$phone){
            background: rgba(module.$normal, .4);
            display: block;
            padding: 1.2rem module.side();
          }
          &:hover{
            text-decoration: underline;
            @media screen and (max-width: module.$phone){
              text-decoration: none;
              background: rgba(module.$normal, .8);
            }
          }
        }
      }
    }
  }
  small{
    display: block;
    text-align: center;
    font-size: .72rem;
    border-top: rgba(module.$white,.08) .1rem solid;
    padding: 1.6rem 0;
  }
}
</style>

<script>
export default {
	data() {
		return {
			currentYear: new Date().getFullYear()
		}
	}
}
</script>